import { useOptimizedEvents, FamilyEvent, EventAttendee } from './useOptimizedEvents';

/**
 * Wrapper around useOptimizedEvents to maintain compatibility with legacy useEvents interface
 * This allows existing components to gradually migrate to the optimized version
 */
export function useEvents(familyId?: string) {
  const {
    events,
    loading,
    createEvent: optimizedCreateEvent,
    updateEvent: optimizedUpdateEvent,
    deleteEvent: optimizedDeleteEvent,
    deleteRelatedRecurringEvents,
    recreateRecurringEvents,
    createBirthdayEventsForYear: optimizedCreateBirthdayEventsForYear,
    getUpcomingEvents,
    updateAttendeeStatus,
    refreshEvents
  } = useOptimizedEvents(familyId);

  // Convert optimized functions to match legacy interface
  const createEvent = async (
    eventData: Parameters<typeof optimizedCreateEvent>[0], 
    attendeeIds: string[] = [],
    silent: boolean = false
  ) => {
    return optimizedCreateEvent(eventData, attendeeIds, silent);
  };

  const updateEvent = async (eventId: string, eventData: Parameters<typeof optimizedUpdateEvent>[1], attendeeIds?: string[]) => {
    return optimizedUpdateEvent(eventId, eventData, attendeeIds);
  };

  const deleteEvent = async (eventId: string) => {
    return optimizedDeleteEvent(eventId);
  };

  const createBirthdayEventsForYear = async (year?: number) => {
    if (!familyId) throw new Error('Family ID is required');
    return optimizedCreateBirthdayEventsForYear(year);
  };

  return {
    events,
    loading,
    createEvent,
    updateEvent,
    deleteEvent,
    deleteRelatedRecurringEvents,
    recreateRecurringEvents,
    getUpcomingEvents,
    updateAttendeeStatus,
    createBirthdayEventsForYear,
    refreshEvents
  };
}

// Re-export the types for compatibility
export type { FamilyEvent, EventAttendee };